// @flow

import type { Id, ServiceArea } from '../types';
import { find } from 'rambda';

export const isServiceAreaVirtual = (serviceAreaId: Id, areas: ServiceArea[]) =>
  !!find((area: ServiceArea) => area.id === serviceAreaId && area.isVirtual, areas);
